export class ListDetails {
	constructor() {
		this.container = document.querySelector('.listDetails');
		this.summary = this.container.querySelectorAll('.listDetails-list h4 ');
	}

	init() {
		this.addSummaryEvent();
	}

	addSummaryEvent() {
		this.summary.forEach((summary) => {
			summary.addEventListener('click', () => {
				this.toggleList(summary);
			});
		});
	}

	toggleList(summary) {
		const listItem = summary.closest('.listDetails-listItem');
		const isActive = this.container.querySelector(
			'.listDetails-list > li.active'
		);

		if (listItem.classList.contains('active')) {
			this.closeItem(listItem);
		} else {
			const listContent = listItem.querySelector('.listDetails-text');
			const height = listContent.getBoundingClientRect().height;

			if (isActive) {
				this.closeItem(
					this.container.querySelector(
						'.listDetails-list > li.active'
					)
				);
			}
			this.openItem(listItem, height);
		}
	}

	closeItem(item) {
		item.querySelector('.listDetails-listContent').style.height = 0;
		item.classList.remove('active');
	}

	openItem(item, height) {
		console.log(height);
		item.classList.add('active');
		item.querySelector(
			'.listDetails-listContent'
		).style.height = `${height}px`;
	}
}
